import { makeStyles } from '@material-ui/core/styles';

export const useConversationStyles = makeStyles({
  conversationContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: '100%',
    minHeight: 0,
    minWidth: 300,
    position: 'relative',
    overflow: 'hidden'
  }
});
